import moment from 'moment';
import History from '@/utils/history';
import {
    ConstantUtil,
} from '@/utils/ConstantUtil';
import Utils from '@/utils/Utils';
import Balance from '@/utils/balance';
import Footer from '../components/common/Footer';
import { verify } from 'crypto';
import Config from '@/utils/Config';


export default {
    name: 'History',
    components: {
        Footer,
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    data() {
        return {
            balances: [],
            Config,
            searchFunction: false,
            tagStatus: Utils.getQueryObject().type ? Utils.getQueryObject().type : Config.defaultHistoryTag,
            detail: false,
            historyList: [],
            pageNo: 0,
            nomore: false,
        };
    },
    mounted() {
        const self = this;
        let currUser = '';
        let token = '';
        let email = '';
        if (!Config.CenterTrade) {
            const AccountList = self.$store.state.accountList;
            const currAccountIndex = self.$store.state.currAccountIndex;
            currUser = AccountList[currAccountIndex].userid;
        } else {
            console.log(this.user, 'this.user');
            currUser = this.$store.state.user.bttUserid;
            token = this.$store.state.user.token;
            email = this.$store.state.user.email;
        }
        Balance.getBalance(currUser, 'balance', token, email).then((res) => {
            this.getHistory(this.tagStatus);
            self.balances = res.balances.reduce((result, item) => {
                const balance = result;
                balance[item.id] = item;
                return balance;
            }, {});
        });
    },
    filters: {
        blockTxUrl(assetid, id, balances) {
            if (balances[assetid]) {
                console.log(ConstantUtil, 'ConstantUtil', balances[assetid].chain_type);
                return `${ConstantUtil.Links[balances[assetid].chain_type][process.env.NODE_RUN_ENV]}${id}`;
            }
            return '';
        },
        chainName(val, balances) {
            return ConstantUtil.Links[balances[val].chain_type].name;
        },
        btUrl(val) {
            if (process.env.NODE_RUN_ENV === 'TEST') {
                return `https://explorer_test.bytetrade.com/transaction-info.html?id=${val}&blockType=1`;
            }
            return `https://explorer.bytetrade.com/transaction-info.html?id=${val}&blockType=1`;
        },
    },
    watch: {
        currAccountIndex(n, o) {
            const self = this;
            if (n !== o) {
                self.userId = self.$store.state.accountList[n].userid;
                self.getHistory(self.tagStatus);
            }
        },
    },

    computed: {
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },
    },
    methods: {
        showStatus(status) {
            const statusMap = {
                0: 'Wait pay',
                1: 'Success',
                2: 'Pay success',
                3: 'Verifing',
                4: 'Sented',
                11: 'Refund',
                12: 'Rejected',
                13: 'Fail',
            };
            if (statusMap[status]) {
                return statusMap[status];
            }
            return status;
        },
        prevPage() {
            const self = this;
            let currPage = self.pageNo;
            currPage -= 1;
            self.pageNo = currPage;
            self.nomore = false;
            self.getHistory(self.tagStatus, currPage);
        },
        nextPage() {
            const self = this;
            let currPage = self.pageNo;
            currPage += 1;
            self.pageNo = currPage;
            self.getHistory(self.tagStatus, currPage);
        },
        getBalance() {

        },
        getHistory(type = 'deposit', o = 0, limit = 50) {
            const self = this;
            let userId = '';
            if(Config.CenterTrade) {
                userId = this.$store.state.user.bttUserid;
            } else {
                userId = self.$store.getters.currAccount.userid;
            }
            History.getHistory(userId, type, o, limit).then((res) => {
                const oriList = res.result || res.data;

                oriList.forEach((v) => {
                    let times = 1000;
                    times = v.createTime ? times : 1;
                    v.createTime = moment((v.createTime || v.createAt) * times).format('YYYY-MM-DD HH:mm:ss');
                    v.isDetail = false;
                });
                if (oriList.length === 0) {
                    self.nomore = true;
                    return;
                } else if (oriList.length < limit) {
                    self.nomore = true;
                }
                self.historyList = oriList;
            });
        },
        changeTagStatus(type) {
            const self = this;
            self.historyList = [];
            self.tagStatus = type;
            self.getHistory(type);
        },
        showOrHideDetail(i) {
            const self = this;
            const status = self.historyList[i].isDetail;
            self.historyList[i].isDetail = !status;
            self.historyList = self.historyList;
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/history.js